import "./Common/AutoplaySettings.api";
export { AutoplaySettingsDesktop } from "./Desktop/AutoplaySettingsDesktop.container";
export { AutoplaySettingsMobile } from "./Mobile/AutoplaySettingsMobile.container";

export type AutoplaySettingsActions =
  | "autoplay.available.set"
  | "autoplay.roundsleft.set"
  | "autoplay.rounds.reset"
  | "autoplay.start"
  | "autoplay.stop"
  | "autoplay.rounds.set"
  | "autoplay.selectedrounds.changerequest"
  | "autoplay.roundsvalues.set"
  | "autoplay.settings.reset"
  | "autoplay.settings.set"
  | "autoplay.setting.set"
  | "autoplay.settings.changerequest";
